import { render, staticRenderFns } from "./Sequences.vue?vue&type=template&id=3979e072&scoped=true"
import script from "./Sequences.vue?vue&type=script&lang=js"
export * from "./Sequences.vue?vue&type=script&lang=js"
import style0 from "./Sequences.vue?vue&type=style&index=0&id=3979e072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979e072",
  null
  
)

export default component.exports